import { Col, Container, Row } from "react-bootstrap";
import AdditionalServiceForm from "../../../Components/Forms/AdditionalServiceForm/AdditionalServiceForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditAdditionalServiceMutation, useGetAdditionalServiceByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";

export default function EditAdditionalServicePage() {

    const { additionalServiceId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetAdditionalServiceByIdQuery(additionalServiceId, { skip: !additionalServiceId })
    const additionalServiceData = data || {}

    const [
        editAdditionalService,
        {
            isLoading: isLoadingEdit,
            error: editError
        }
    ] = useEditAdditionalServiceMutation()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const updatedAdditionalService = await editAdditionalService({
            additionalServiceId: additionalServiceId,
            additionalServiceInfo: values
        }).unwrap()
        if (updatedAdditionalService._id) {
            dispatch(navigateTo(`/additional-service/${updatedAdditionalService._id}`))
        }
        return updatedAdditionalService
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Additional Service</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {additionalServiceId && additionalServiceData && !isLoading && (
                        <AdditionalServiceForm
                            initialValues={{
                                ...additionalServiceData,
                            }}
                            disabled={isLoading || isLoadingEdit}
                            onSubmit={handleSubmit}
                        />
                    )}

                </Col>
            </Row>
        </Container>
    )
}
